// @flow
export const NEW_ORDER_KEYWORD_FILTER_SET: 'NEW_ORDER_KEYWORD_FILTER_SET' =
  'NEW_ORDER_KEYWORD_FILTER_SET';
export const NEW_ORDER_CATALOG_TYPE_FILTER_SET: 'NEW_ORDER_CATALOG_TYPE_FILTER_SET' =
  'NEW_ORDER_CATALOG_TYPE_FILTER_SET';
export const NEW_ORDER_CUSTOMER_SET: 'NEW_ORDER_CUSTOMER_SET' =
  'NEW_ORDER_CUSTOMER_SET';
export const NEW_ORDER_CATALOG_SET: 'NEW_ORDER_CATALOG_SET' =
  'NEW_ORDER_CATALOG_SET';
export const NEW_ORDER_DETAILS_OPEN: 'NEW_ORDER_DETAILS_OPEN' =
  'NEW_ORDER_DETAILS_OPEN';
export const NEW_ORDER_DETAILS_CLOSE: 'NEW_ORDER_DETAILS_CLOSE' =
  'NEW_ORDER_DETAILS_CLOSE';
export const NEW_ORDER_EXPORT_AVAILABILITY_OPEN: 'NEW_ORDER_EXPORT_AVAILABILITY_OPEN' =
  'NEW_ORDER_EXPORT_AVAILABILITY_OPEN';
export const NEW_ORDER_EXPORT_AVAILABILITY: 'NEW_ORDER_EXPORT_AVAILABILITY' =
  'NEW_ORDER_EXPORT_AVAILABILITY';
export const NEW_ORDER_EXPORT_AVAILABILITY_CLOSE: 'NEW_ORDER_EXPORT_AVAILABILITY_CLOSE' =
  'NEW_ORDER_EXPORT_AVAILABILITY_CLOSE';
export const NEW_ORDER_OFFLINE_ORDER_FORM_RECEIVE: 'NEW_ORDER_OFFLINE_ORDER_FORM_RECEIVE' =
  'NEW_ORDER_OFFLINE_ORDER_FORM_RECEIVE';
export const NEW_ORDER_OFFLINE_ORDER_FORM_FAIL_TO_RECEIVE: 'NEW_ORDER_OFFLINE_ORDER_FORM_FAIL_TO_RECEIVE' =
  'NEW_ORDER_OFFLINE_ORDER_FORM_FAIL_TO_RECEIVE';
export const NEW_ORDER_OFFLINE_ORDER_FORM_CLEAR: 'NEW_ORDER_OFFLINE_ORDER_FORM_CLEAR' =
  'NEW_ORDER_OFFLINE_ORDER_FORM_CLEAR';
export const NEW_ORDER_RESET: 'NEW_ORDER_RESET' = 'NEW_ORDER_RESET';
